<template>
  <div id="rechargeCardList">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>数据中心</el-breadcrumb-item>
          <el-breadcrumb-item>{{title}}</el-breadcrumb-item>
          <el-breadcrumb-item>月卡续费报表</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="80px">
      <el-row>
        <el-col :span="24">
          <el-form-item label="客户名称::">
            <el-select v-model="pageSearch.fCustID"
                       style="width:200px"
                       filterable
                       clearable
                       @change="changeCust"
                       placeholder="请选择客户">
              <el-option v-for="item in cust_list"
                         :key="item.fCustID"
                         :label="item.unionName"
                         :value="item.fCustID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="月卡分组::">
            <el-select v-model="pageSearch.fGroupID"
                       placeholder="请选择分组"
                       style="width:200px"
                       clearable
                       filterable>
              <el-option v-for="item in cardGroups"
                         :key="item.fGroupID"
                         :label="item.fGroupName"
                         :value="item.fGroupID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="月卡类型::">
            <el-select v-model="pageSearch.fCardTypeID"
                       clearable
                       filterable
                       placeholder="请选择月卡类型"
                       style="width:200px;">
              <el-option v-for="(e, i) in cardTypeList"
                         :key="i"
                         :label="e.text"
                         :value="e.value">
              </el-option>
            </el-select>
          </el-form-item>

        </el-col>
        <el-col :span="24">
          <el-form-item label="开始时间::">
            <el-date-picker v-model="startTime"
                            style="width:200px"
                            type="datetime"
                            :clearable="false"
                            :picker-options="startMonthOption"
                            placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间::">
            <el-date-picker v-model="endTime"
                            style="width:200px"
                            :clearable="false"
                            type="datetime"
                            :picker-options="endMonthOption"
                            placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="车牌号::">
            <el-input placeholder="请输入车牌"
                      style="width:200px"
                      v-model="pageSearch.fPlateCode"
                      class="input-with-select">
            </el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="page_list">查询</el-button>
            <el-button type="success"
                       size="small"
                       icon="el-icon-share"
                       :loading="export_loading"
                       v-if="is_export"
                       @click="exportData">{{export_msg}}</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  ref="dt"
                  :summary-method="getSummaries"
                  show-summary
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fOpLastTime"
                           width="160"
                           label="操作时间">
          </el-table-column>

          <el-table-column prop="fCustNo"
                           width="80"
                           label="客户编号">
          </el-table-column>
          <el-table-column prop="fGroupName"
                           width="80"
                           label="月卡分组">
          </el-table-column>
          <el-table-column prop="fCardTypeName"
                           label="月卡类型">
          </el-table-column>
          <el-table-column prop="fCardNo"
                           label="月卡卡号">
          </el-table-column>
          <el-table-column prop="fCustName"
                           label="用户姓名">
          </el-table-column>

          <el-table-column prop="fPlateList"
                           width="100"
                           label="车牌号">
          </el-table-column>
          <el-table-column prop="fBatStartTime"
                           width="150"
                           label="月卡开始时间">
          </el-table-column>
          <el-table-column prop="fBatEndTime"
                           width="150"
                           label="月卡结束时间">
          </el-table-column>
          <el-table-column prop="fPayAmount"
                           align="right"
                           label="储值金额">
          </el-table-column>
          <el-table-column prop="fPaySecs"
                           label="储值时间">
          </el-table-column>
          <el-table-column prop="fPayCount"
                           label="储值次数">
          </el-table-column>
          <el-table-column prop="fRemark"
                           label="备注">
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="100">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="viewCard(scope.$index, scope.row)">月卡</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <cardView ref="child"
              cardActiveName="cardList"
              :choiceCusts="cust_list"></cardView>
  </div>
</template>

<script>
import cardView from '../../components/cardView'
import { report as api } from '../../api/report'
import * as park from '../../api/park'
import * as user from '../../api/user'
import * as card from '../../api/card'
import { cust as apiCust } from '../../api/cust'
// import $ from 'jquery'
import Clipboard from 'clipboard'
export default {
  name: 'rechargeCardList',
  components: { cardView },
  data () {
    return {
      is_roadSide: false,
      currentDate: '',
      cardTypeList: [],
      cardGroups: [],
      dialogVisible: false,
      dialogTitle: '',
      title: '业务数据中心',
      form: {},
      is_export: false,
      tableHeight: 0,
      loading: false,
      export_loading: false,
      export_msg: '导出',
      pageData: [],
      cust_list: [],
      payType_list: [],
      startTime: '',
      endTime: '',
      pageCount: 0,
      total: {
        fPayAmount: ''
      },
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustID: '',
        fGroupID: '',
        fCardTypeID: '',
        fStartTime: '',
        fEndTime: '',
        fPlateCode: '',
        isExport: 0
      },
      startMonthOption: {
      },
      endMonthOption: {
      }
    }
  },
  methods: {
    viewCard (index, row) {
      this.$refs.child.viewCard(row, true)
    },
    page_list (index) {
      if ((this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.isExport = 0
      api.rechargeCardDataList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          // console.log(res)
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data || []
            this.pageCount = data.Data.count
            this.total = { fTotalPayAmount: data.Data.fTotalPayAmount, fTotalPaySecs: data.Data.fTotalPaySecs, fTotalPayCount: data.Data.fTotalPayCount }
            setTimeout(() => { this.$refs['dt'].doLayout() }, 100)
          } else {
            this.$message.error('提示：查询月卡续费数据失败')
          }
        }
      })
    },
    getSummaries (param) {
      var sums = []
      sums[0] = '合计'
      sums[10] = this.total.fTotalPayAmount
      sums[11] = this.total.fTotalPaySecs
      sums[12] = this.total.fTotalPayCount
      // var dts = document.querySelectorAll('.el-table__footer-wrapper tbody.has-gutter>tr>td')
      // if (dts && dts.length >= 10) {
      //   $(dts[10]).attr('colspan', 3)
      //   $(dts[10]).css('text-align', 'right')
      // }
      return sums
    },
    changeCust (fCustID) {
      this.pageSearch.fGroupID = ''
      this.cardGroups = []
      if (!fCustID) { return }
      // 加载
      card.getCardGroupByCustId({ fCustID: fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cardGroups = data.Data
            // if (this.cust_list && this.cust_list.length === 1) {
            //   this.pageSearch.fCustID = this.cust_list[0].fCustID
            // }
          } else {
            this.$message.error('提示：加载月卡分组列表失败')
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    copyData () {
      var clipboard = new Clipboard('.copy')
      clipboard.on('success', e => {
        this.$message({
          message: '提示：复制成功',
          type: 'success'
        })
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        this.$message({
          message: '提示：该浏览器不支持自动复制',
          type: 'warning'
        })
        // 释放内存
        clipboard.destroy()
      })
    },
    getCurrentYearLast (startTime, endTime) {
      var end = new Date(startTime.getFullYear() + '-' + endTime.getMonth() + '-' + endTime.getDate() + ' 23:59:59')
      if (startTime > end) {
        end = new Date(startTime.getFullYear() + '-' + startTime.getMonth() + '-' + startTime.getDate() + ' 23:59:59')
      }
      return end
    },
    selectStartMonth () {
      var endYear = this.endTime.getFullYear()
      var startYear = this.startTime.getFullYear()
      if (endYear !== startYear) {
        this.endTime = this.getCurrentYearLast(this.startTime, this.endTime)
      }
      // this.endMonthOption = {
      //   disabledDate: (time) => {
      //     if (this.startTime !== '') {
      //       var endYear = this.endTime.getFullYear()
      //       var startYear = this.startTime.getFullYear()
      //       return time.getTime() < this.startTime.getTime() || endYear !== startYear
      //     }
      //   }
      // }

      var dateyyyy = this.$dateFormat(this.startTime, 'yyyy')
      if (this.currentDate !== dateyyyy) {
        apiCust.allPayType({ date: dateyyyy, type: 'card' }).then(res => {
          if (res && res.data) {
            var data = res.data
            if (data.IsOk) {
              this.currentDate = dateyyyy
              this.payType_list = data.Data || []
            } else {
              this.$message.error('提示：加载支付方式失败')
            }
          }
        })
      }
    },
    selectEndMonth () {
      var endYear = this.endTime.getFullYear()
      var startYear = this.startTime.getFullYear()
      if (endYear !== startYear) {
        this.startTime = new Date(this.endTime.getFullYear(), this.endTime.getMonth(), 1, 0, 0, 0)
      }
      // this.startMonthOption = {
      //   disabledDate: (time) => {
      //     if (this.endTime !== '') {
      //       var endYear = this.endTime.getFullYear()
      //       var startYear = this.startTime.getFullYear()
      //       return time.getTime() > this.endTime.getTime() || endYear !== startYear
      //     }
      //   }
      // }
    },
    exportData () {
      if ((this.pageSearch.fCustID || '').trim().length <= 0) {
        this.$message.error('提示：请先选择客户')
        return false
      }
      this.pageSearch.fStartTime = this.$dateFormat(this.startTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.fEndTime = this.$dateFormat(this.endTime, 'yyyy-MM-dd hh:mm:ss')
      this.pageSearch.isExport = 1
      this.export_loading = true
      this.export_msg = '导出中……'
      var fileName = '所有客户'
      if ((this.pageSearch.fCustID || '').trim().length > 0) {
        var custArr = (this.cust_list || []).filter((item) => {
          return item.fCustID === this.pageSearch.fCustID
        })
        fileName = custArr.length > 0 ? custArr[0].unionName : ''
      }
      api.rechargeCardDataList(this.pageSearch).then(res => {
        this.export_loading = false
        this.export_msg = '导出'
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.fileDownload(data.Data, fileName + '_电子支付月卡续费报表.xls')
            }
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    init () {
      // var firstDay = new Date()
      // firstDay.setDate(1)
      // this.startTime = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate(), 0, 0, 0)
      var today = new Date()
      this.startTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0)
      this.endTime = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)

      // this.selectStartMonth()
      park.getCustByGroup({ fCustTypeID: 0 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            if (this.cust_list && this.cust_list.length === 1) {
              this.pageSearch.fCustID = this.cust_list[0].fCustID
              this.changeCust(this.pageSearch.fCustID)
            }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
      card.loadCardTypeList().then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cardTypeList = data.Data.cardTypeList || []
          } else {
            this.$message.error('提示：加载支付方式失败')
          }
        }
      })
      user.getCurrentUserPers({ perTypeId: 1020000 }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            if (data.Data) {
              this.is_export = data.Data.data.is_export
            }
          } else {
            this.$message.error('提示：加载当前用户权限信息失败')
          }
        }
      })
    },
    handleDetail (index, row) {
      this.form = row
      this.dialogTitle = '【' + row.fCustNo + '】' + row.fCardNo + '-月卡续费详情'
      this.dialogVisible = true
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 250
      obj.tableHeight = clientHeight
    }
  },
  created () {

  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        Object.assign(this.$data, this.$options.data())
        this.init()
      },
      // 深度观察监听
      deep: true
    }
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style >
/* dialog弹出框样式 */
#rechargeCardList .el-dialog {
  min-width: 840px;
}
#rechargeCardList .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#rechargeCardList .el-dialog__title {
  color: white;
}
#rechargeCardList .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#rechargeCardList .el-dialog__body {
  padding: 3px 10px;
  font-size: 13px;
  /* font-family: "宋体"; */
}
#rechargeCardList .fRemark > .el-textarea__inner {
  height: 100px;
}
#rechargeCardList .fRemark_row .el-form-item__content {
  height: 100px;
}
#rechargeCardList .fRemark_big > .el-textarea__inner {
  height: 135px;
}
#rechargeCardList .fRemark_row_big .el-form-item__content {
  height: 135px;
}
#rechargeCardList .el-input.is-disabled .el-input__inner,
#rechargeCardList .el-textarea.is-disabled .el-textarea__inner {
  color: #606266;
}
</style>
<style scoped>
.el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
.danger {
  color: #f56c6c;
}
.success {
  color: #67c23a;
}
</style>



// WEBPACK FOOTER //
// src/view/report/rechargeCardList.vue